import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {
  CopilotChatPayload,
  CopilotChatReference,
  CopilotChatOrg,
} from '@github-ui/copilot-chat/utils/copilot-chat-types'

export interface ExtendedCopilotChatPayload extends CopilotChatPayload {
  findFileWorkerPath: string
  refs?: CopilotChatReference[]
  ssoOrganizations?: CopilotChatOrg[]
}

export function useChatPayload() {
  return useQuery<ExtendedCopilotChatPayload>({
    queryKey: ['pull-request-side-panel', 'chat-payload'],
    queryFn: async () => {
      const resp = await verifiedFetchJSON('/github-copilot/chat')
      if (!resp.ok) {
        throw new Error(`Failed to fetch chat provider: ${resp.statusText}`)
      }
      return (await resp.json()) as ExtendedCopilotChatPayload
    },
    staleTime: Infinity,
  })
}
